import { ChangeDetectionStrategy, Component, output } from '@angular/core';

import { EinreichungDirective } from '../directives';
import { EinreichungStep } from '../enums';
import { Antrag } from '../types';

@Component({
  selector: 'ebeihilfe-einreichung',
  template:
    '<div einreichung (einreichungStepEmitter)="stepFromDirective($event)" (antragChangeEmitter)="antragFromDirectiveChanged($event)" (hasUiEmitter)="hasUIFlagChanged($event)"></div>',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [EinreichungDirective],
})
export class EbeihilfeEinreichungComponent {
  public stepChangeEmitter = output<EinreichungStep>();
  public antragChangedEmitter = output<Antrag>();
  public hasUiValueChangedEmitter = output<boolean>();

  public stepFromDirective(einreichungsStep: EinreichungStep): void {
    this.stepChangeEmitter.emit(einreichungsStep);
  }

  public antragFromDirectiveChanged(antrag: Antrag): void {
    this.antragChangedEmitter.emit(antrag);
  }

  public hasUIFlagChanged(hasUi: boolean): void {
    this.hasUiValueChangedEmitter.emit(hasUi);
  }
}
